import { request } from '@/utils/request'

export function teacherList(params) {
  return request({
    url: '/api/teacher/list',
    method: 'get',
    params
  })
}

export function teacherSave(data) {
  return request({
    url: '/api/teacher/save',
    method: 'post',
    data
  })
}

export function teacherDel(data) {
  return request({
    url: '/api/teacher/delete',
    method: 'post',
    data
  })
}

export function teacherDetail(params) {
  return request({
    url: '/api/teacher/detail',
    method: 'get',
    params
  })
}
export function teacherChangePassword(data) {
  return request({
    url: '/api/teacher/change_password',
    method: 'post',
    data
  })
}

export function teacherImport (data) {
  return request({
    url: '/api/teacher/import',
    method: 'post',
    data
  })
}

export function getRoleList () {
  return request({
    url: '/api/admin/role/list',
    method: 'get'
  })
}

/* 教学管理 */
// 学期管理
export function semesterSave (data) {
  return request({
    url: '/api/admin/semester/save',
    method: 'post',
    data
  })
}

// 学期详情
export function semesterDetail (params) {
  return request({
    url: '/api/admin/semester/detail',
    method: 'get',
    params
  })
}

// 学生添加
export function studentSave (data) {
  return request({
    url: '/api/student/save',
    method: 'post',
    data
  })
}

// 学生详情
export function studentDetail (params) {
  return request({
    url: '/api/student/detail',
    method: 'get',
    params
  })
}

// 学生导入
export function studentImport (data) {
  return request({
    url: '/api/student/import',
    method: 'post',
    data
  })
}

// 创建班级
export function classSave (data) {
  return request({
    url: '/api/class/save',
    method: 'post',
    data
  })
}

// 班级详情
export function classDetail (params) {
  return request({
    url: '/api/class/detail',
    method: 'get',
    params
  })
}

// 删除班级
export function classDel (data) {
  return request({
    url: '/api/class/delete',
    method: 'post',
    data
  })
}

/* 栏目管理 */
// 栏目列表
export function columnList(params) {
  return request({
    url: '/api/admin/portal/column/list',
    method: 'get',
    params
  })
}

// 栏目上移
export function columnUp(data) {
  return request({
    url: '/api/admin/portal/column/up',
    method: 'post',
    data
  })
}

// 栏目下移
export function columnDown(data) {
  return request({
    url: '/api/admin/portal/column/down',
    method: 'post',
    data
  })
}

// 栏目保存
export function columnSave(data) {
  return request({
    url: '/api/admin/portal/column/save',
    method: 'post',
    data
  })
}

// 栏目删除
export function columnDel(data) {
  return request({
    url: '/api/admin/portal/column/delete',
    method: 'post',
    data
  })
}

// 栏目详情
export function columnDetail(params) {
  return request({
    url: '/api/admin/portal/column/detail',
    method: 'get',
    params
  })
}

// 栏目类型
export function columnType() {
  return request({
    url: '/api/map/column/type',
    method: 'get'
  })
}

// 栏目状态
export function columnStatus() {
  return request({
    url: '/api/admin/portal/info',
    method: 'get'
  })
}

// 页眉页脚详情
export function columnHeaderFooterDetail() {
  return request({
    url: '/api/admin/portal/config/detail',
    method: 'get'
  })
}

// 页眉页脚更改
export function columnHeaderFooter(data) {
  return request({
    url: '/api/admin/portal/config/save',
    method: 'post',
    data
  })
}

/* banner管理 */
// banner列表
export function bannerList(params) {
  return request({
    url: '/api/admin/portal/banner/list',
    method: 'get',
    params
  })
}

// banner保存
export function bannerSave(data) {
  return request({
    url: '/api/admin/portal/banner/save',
    method: 'post',
    data
  })
}

// banner详情
export function bannerDetail(params) {
  return request({
    url: '/api/admin/portal/banner/detail',
    method: 'get',
    params
  })
}

// banner删除
export function bannerDel(data) {
  return request({
    url: '/api/admin/portal/banner/delete',
    method: 'post',
    data
  })
}

/* 新闻管理 */
// 新闻列表
export function newsList(params) {
  return request({
    url: '/api/admin/portal/press/list',
    method: 'get',
    params
  })
}

// 新闻保存
export function newsSave(data) {
  return request({
    url: '/api/admin/portal/press/save',
    method: 'post',
    data
  })
}

// 新闻详情
export function newsDetail(params) {
  return request({
    url: '/api/admin/portal/press/detail',
    method: 'get',
    params
  })
}

// 新闻删除
export function newsDel(data) {
  return request({
    url: '/api/admin/portal/press/delete',
    method: 'post',
    data
  })
}

/* 实验管理 */
// 实验列表
export function labList(params) {
  return request({
    url: '/api/admin/portal/experiment/list',
    method: 'get',
    params
  })
}

// 实验保存
export function labSave(data) {
  return request({
    url: '/api/admin/portal/experiment/save',
    method: 'post',
    data
  })
}

// 实验详情
export function labDetail(params) {
  return request({
    url: '/api/admin/portal/experiment/detail',
    method: 'get',
    params
  })
}

// 实验删除
export function labDel(data) {
  return request({
    url: '/api/admin/portal/experiment/delete',
    method: 'post',
    data
  })
}

// 实验类型
export function labType() {
  return request({
    url: '/api/admin/experiment/type/list',
    method: 'get'
  })
}

// 实验类型的Map
export function labTypeMap() {
  return request({
    url: '/api/map/experiment/type',
    method: 'get'
  })
}

/* 视频管理 */
// 视频列表
export function videoList(params) {
  return request({
    url: '/api/admin/portal/video/list',
    method: 'get',
    params
  })
}

// 视频保存
export function videoSave(data) {
  return request({
    url: '/api/admin/portal/video/save',
    method: 'post',
    data
  })
}

// 视频详情
export function videoDetail(params) {
  return request({
    url: '/api/admin/portal/video/detail',
    method: 'get',
    params
  })
}

// 视频删除
export function videoDel(data) {
  return request({
    url: '/api/admin/portal/video/delete',
    method: 'post',
    data
  })
}

/* 平台介绍管理 */
// 平台介绍列表
export function introduceList(params) {
  return request({
    url: '/api/admin/portal/introduce/list',
    method: 'get',
    params
  })
}

// 平台介绍保存
export function introduceSave(data) {
  return request({
    url: '/api/admin/portal/introduce/save',
    method: 'post',
    data
  })
}

// 平台介绍详情
export function introduceDetail(params) {
  return request({
    url: '/api/admin/portal/introduce/detail',
    method: 'get',
    params
  })
}

// 平台介绍删除
export function introduceDel(data) {
  return request({
    url: '/api/admin/portal/introduce/delete',
    method: 'post',
    data
  })
}

// 角色管理相关接口
export function roleSave (data) {
  return request({
    url: '/api/admin/role/save',
    method: 'post',
    data
  })
}

export function roleDetail (params) {
  return request({
    url: '/api/admin/role/detail',
    method: 'get',
    params
  })
}

// 获取角色权限选项
export function getRolePermissions () {
  return request({
    url: '/api/admin/role/school_permission',
    method: 'get'
  })
}

// 获取角色下的用户
export function getRoleUsers (params) {
  return request({
    url: '/api/admin/role/user_list',
    method: 'get',
    params
  })
}

/* 学院管理 */
// 学院列表
export function collegeList(params) {
  return request({
    url: '/api/admin/school/org/list',
    method: 'get',
    params
  })
}

// 学院保存
export function collegeSave(data) {
  return request({
    url: '/api/admin/school/org/save',
    method: 'post',
    data
  })
}

// 学院删除
export function collegeDel(data) {
  return request({
    url: '/api/admin/school/org/delete',
    method: 'post',
    data
  })
}

/* 实验类别管理 */
// 实验类别列表
export function experimentTypeList(params) {
  return request({
    url: '/api/admin/experiment/type/list',
    method: 'get',
    params
  })
}

// 实验类别保存
export function experimentTypeSave(data) {
  return request({
    url: '/api/admin/experiment/type/save',
    method: 'post',
    data
  })
}

// 实验类别删除
export function experimentTypeDel(data) {
  return request({
    url: '/api/admin/experiment/type/delete',
    method: 'post',
    data
  })
}
// 实训管理列表
export function getTrainingRoomList(params) {
  return request({
    url: '/api/training_room/list',
    method: 'get',
    params
  })
}
// 实训管理添加、编辑保存
export function postTrainingRoomSave(data) {
  return request({
    url: '/api/training_room/save',
    method: 'post',
    data
  })
}
// 实训管理关联设备列表
export function getTrainingEquipmentUsableList(params) {
  return request({
    url: '/api/training_equipment/usableList',
    method: 'get',
    params
  })
}
// 实训列表开启的
export function getTrainingRoomUsableList(params) {
  return request({
    url: '/api/training_room/usableList',
    method: 'get',
    params
  })
}
// 实训管理详情
export function getTrainingRoomDetail(params) {
  return request({
    url: '/api/training_room/detail',
    method: 'get',
    params
  })
}
// 实训设备管理
export function getTrainingEquipmentList(params) {
  return request({
    url: '/api/training_equipment/list',
    method: 'get',
    params
  })
}
// 实训设备管理详情
export function getTrainingEquipmentDetail(params) {
  return request({
    url: '/api/training_equipment/detail',
    method: 'get',
    params
  })
}
// 实训设备管理新增/编辑保存
export function postTrainingEquipmentSave(data) {
  return request({
    url: '/api/training_equipment/save',
    method: 'post',
    data
  })
}
// 实训室预约管理列表
export function getTrainingRoomApplyList(params) {
  return request({
    url: '/api/training_room_apply/list',
    method: 'get',
    params
  })
}
// 实训室预约列表
export function getTrainingRoomApplyTrainingRoomList(params) {
  return request({
    url: '/api/training_room_apply/training_room/list',
    method: 'get',
    params
  })
}
// 实训室预约-预约
export function postTrainingRoomApplySave(data) {
  return request({
    url: '/api/training_room_apply/save',
    method: 'post',
    data
  })
}
// 实训室预约-审批
export function postTrainingRoomApplyRatify(data) {
  return request({
    url: '/api/training_room_apply/ratify',
    method: 'post',
    data
  })
}
// 实训室预约-详情
export function getTrainingRoomApplyDetail(params) {
  return request({
    url: '/api/training_room_apply/detail',
    method: 'get',
    params
  })
}
// 实训室预约-取消预约
export function postTrainingRoomApplyCancel(data) {
  return request({
    url: '/api/training_room_apply/cancel',
    method: 'post',
    data
  })
}
// 实训室预约-所有老师
export function getTeacherListAll(params) {
  return request({
    url: '/api/teacher/list/all',
    method: 'get',
    params
  })
}
// 筛选实训室所有列表
export function getTrainingEquipmentRoomList(params) {
  return request({
    url: '/api/training_equipment/room/list',
    method: 'get',
    params
  })
}
// 未关联实训室数量
export function getTrainingEquipmentNoRoomTotal(params) {
  return request({
    url: '/api/training_equipment/noRoomTotal',
    method: 'get',
    params
  })
}
// 排课的课程列表
export function arrangeLesson(params) {
  return request({
    url: '/api/training_schedule/lesson/list',
    method: 'get',
    params
  })
}
// 排课的实训室列表
export function arrangeRoom(params) {
  return request({
    url: '/api/training_schedule/training_room/list',
    method: 'get',
    params
  })
}
// 排课的保存
export function arrangeSave(data) {
  return request({
    url: '/api/training_schedule/save',
    method: 'post',
    data
  })
}
// 排课的删除
export function arrangeDelete(data) {
  return request({
    url: '/api/training_schedule/cancel',
    method: 'post',
    data
  })
}
// 排课筛选项
export function arrangeFilter(params) {
  return request({
    url: '/api/training_schedule/search_options',
    method: 'get',
    params
  })
}
// 排课列表
export function arrangeList(params) {
  return request({
    url: '/api/training_schedule/list',
    method: 'get',
    params
  })
}
// 操作日志
export function getMonitorList(params) {
  return request({
    url: '/api/admin/monitor/list',
    method: 'get',
    params
  })
}
// 敏感词保存
export function postSensitiveWordsSave(data) {
  return request({
    url: '/api/admin/sensitive/words/save',
    method: 'post',
    data
  })
}
// 敏感词详情
export function getSensitiveWordsDetail(params) {
  return request({
    url: '/api/admin/sensitive/words/detail',
    method: 'get',
    params
  })
}
// 子栏目列表
export function getPortalSubcolumnList(params) {
  return request({
    url: '/api/admin/portal/subcolumn/list',
    method: 'get',
    params
  })
} // 子栏目列表删除
export function postPortalSubcolumnDelete(data) {
  return request({
    url: '/api/admin/portal/subcolumn/delete',
    method: 'post',
    data
  })
}
// 子栏目创建编辑保存
export function postPortalSubcolumnSave(data) {
  return request({
    url: '/api/admin/portal/subcolumn/save',
    method: 'post',
    data
  })
}
// 子栏目下移
export function postPortalSubclolumnDown(data) {
  return request({
    url: '/api/admin/portal/subcolumn/down',
    method: 'post',
    data
  })
}
// 子栏目上移
export function postPortalSubclolumnUp(data) {
  return request({
    url: '/api/admin/portal/subcolumn/up',
    method: 'post',
    data
  })
}
// 子栏目中 查询归属的栏目
export function getPortalTopcolumnList(params) {
  return request({
    url: '/api/admin/portal/topcolumn/list',
    method: 'get',
    params
  })
}
// 子栏目详情
export function getPortalSubcolumnDetail(params) {
  return request({
    url: '/api/admin/portal/subcolumn/detail',
    method: 'get',
    params
  })
}
// 评论点赞
export function postPortalSubcolumnLike(data) {
  return request({
    url: '/api/resource/comment/like',
    method: 'post',
    data
  })
}
// 评论取消点赞
export function postPortalSubcolumnUnlike(data) {
  return request({
    url: '/api/resource/comment/unlike',
    method: 'post',
    data
  })
}

// 资源类型的map
export function resourceTypeMap() {
  return request({
    url: '/api/map/res_type',
    method: 'get'
  })
}
// 招聘保存编辑
export function postportalSubcolumnSave(data) {
  return request({
    url: '/api/admin/portal/job/save',
    method: 'post',
    data
  })
}
// 获取专业
export function getPortalSubcolumnTopList(params) {
  return request({
    url: '/api/map/profession/top/list',
    method: 'get',
    params
  })
}
// 招聘详情
export function getPortalJobDetail(params) {
  return request({
    url: '/api/admin/portal/job/detail',
    method: 'get',
    params
  })
}
// 评论管理上线
export function postCommentStatusOn(data) {
  return request({
    url: '/api/admin/comment/status_on',
    method: 'post',
    data
  })
}
// 评论管理下线
export function postCommentStatusOff(data) {
  return request({
    url: '/api/admin/comment/status_off',
    method: 'post',
    data
  })
}
// 简历下载
export function postResumeDownload(data) {
  return request({
    url: '/api/admin/portal/resume/download',
    method: 'post',
    data
  })
}

// 校外师生保存
export function externalUserSave(data) {
  return request({
    url: '/api/admin/external_user/save',
    method: 'post',
    data
  })
}

// 课程审核列表
export function courseReviewList(params) {
  return request({
    url: '/api/portal-lesson-apply/list',
    method: 'get',
    params
  })
}
// 课程审核详情
export function courseReviewDetail(params) {
  return request({
    url: '/api/portal-lesson-apply/detail',
    method: 'get',
    params
  })
}
// 课程审核提交
export function courseReviewSave(data) {
  return request({
    url: '/api/portal-lesson-apply/audit',
    method: 'post',
    data
  })
}

// 课程审核删除
export function courseReviewDel(data) {
  return request({
    url: '/api/portal-lesson-apply/delete',
    method: 'post',
    data
  })
}

// 课程设置
export function courseSet(data) {
  return request({
    url: '/api/portal-lesson-apply/setting',
    method: 'post',
    data
  })
}

// 获取学期
export function getSemesterList(params) {
  return request({
    url: '/api/map/semester',
    method: 'get',
    params
  })
}

// 获取门户课程设置
export function getCourseSetting(params) {
  return request({
    url: '/api/portal-lesson-apply/setting-detail',
    method: 'get',
    params
  })
}
// 更新教师专业
export function updateTeacherProfession(data) {
  return request({
    url: '/api/teacher/set-profession',
    method: 'post',
    data
  })
}

// 更新教师性别
export function updateTeacherRole(data) {
  return request({
    url: '/api/teacher/set-role',
    method: 'post',
    data
  })
}

// 移除班级学生
export function removeClassStudent(data) {
  return request({
    url: '/api/class/remove-student',
    method: 'post',
    data
  })
}

// 获取可添加的学生列表
export function getAvailableStudents(params) {
  return request({
    url: '/api/student/list',
    method: 'get',
    params
  })
}

// 获取行政班可添加的学生列表
export function getAvailableStudentsForAdmin(params) {
  return request({
    url: '/api/student/no-administrative-class-list',
    method: 'get',
    params
  })
}

// 添加学生到班级
export function addClassStudent(data) {
  return request({
    url: '/api/class/add-student',
    method: 'post',
    data
  })
}

// 获取班级列表
export function getClassList(params) {
  return request({
    url: '/api/class/list',
    method: 'get',
    params
  })
}

// 获取所有班级
export function getAllClassList(params) {
  return request({
    url: '/api/admin/map/class',
    method: 'get',
    params
  })
}

// 移动学生到其他班级
export function moveStudent(data) {
  return request({
    url: '/api/student/move2class',
    method: 'post',
    data
  })
}

// 外部人员导入
export function externalImport(data) {
  return request({
    url: '/api/admin/external_user/import',
    method: 'post',
    data
  })
}

// 外部人员保存
export function externalSave(data) {
  return request({
    url: '/api/admin/external_user/save',
    method: 'post',
    data
  })
}

// 外部人员详情
export function externalDetail(params) {
  return request({
    url: '/api/admin/external_user/detail',
    method: 'get',
    params
  })
}
